import styled from "styled-components";

export const _OrderAccordionRoot = styled("div")<{}>(() => {
  return {
    display: "flex",
    flexDirection: "column",
    gap: 8,
  };
});
